<template>
  <div class="dashboard">
    <div class="page-top-section">
      <div class="left">
        <h2>AUCTION HOUSES</h2>
        <div class="page-indication">
          <p>Auction Houses</p>
          <i class="fa-solid fa-caret-right"></i>
          <p>Auction Houses List</p>
          <i class="fa-solid fa-caret-right"></i>
          <p class="active">{{ actionType }} Auction House</p>
        </div>
      </div>
      <div class="right">
        <div class="export-btn">
          <router-link :to="{ name: 'AdminAuctionHouses' }" class="btn">
            <i class="fa-solid fa-times"></i>
            <span>Cancel</span>
          </router-link>
        </div>
        <div class="add-btn">
          <button class="btn" @click="saveItem()" v-if="actionType == 'Add'">
            <i class="fa-solid fa-plus"></i>
            <span>Save</span>
          </button>
          <button class="btn" @click="updateItem()" v-else>
            <i class="fa-solid fa-save"></i>
            <span>Update</span>
          </button>
        </div>
      </div>
    </div>
    <div class="page-content-section">
      <div class="left">
        <div class="form">
          <div class="form-body">
            <div iv class="form-group">
              <div class="form-header">
                <h3>General Information</h3>
              </div>
              <div class="input-group">
                <div class="input-group-item">
                  <label for="artwork-name">Auction House(ENG)</label>
                  <input
                    type="text"
                    id="artwork-name"
                    placeholder="Type Auction House(ENG) here. . ."
                    v-model="newItem.auction_house_name_eng"
                  />
                </div>
                <div class="input-group-item">
                  <label for="artwork-location">경매장(KOR)</label>
                  <input
                    type="text"
                    id="artwork-location"
                    placeholder="경매장. . ."
                    v-model="newItem.auction_house_name_kor"
                  />
                </div>
                <div class="input-group-item">
                  <label for="artwork-location">Auction Location(ENG)</label>
                  <input
                    type="text"
                    id="artwork-location"
                    placeholder="Auction Location(ENG)"
                    v-model="newItem.auction_house_location_eng"
                  />
                </div>
                <div class="input-group-item">
                  <label for="artwork-location">경매전시장소(KOR)</label>
                  <input
                    type="text"
                    id="artwork-location"
                    placeholder="경매전시장소"
                    v-model="newItem.auction_house_location_kor"
                  />
                </div>
                <div class="input-group-item">
                  <label for="artwork-location"
                    >Auction House e-mail(Global)</label
                  >
                  <input
                    type="email"
                    id="artwork-location"
                    placeholder="Auction House e-mail(Global)"
                    v-model="newItem.auction_house_email"
                  />
                </div>
                <div class="input-group-item">
                  <label for="artwork-location"
                    >Auction House tel(Global)</label
                  >
                  <input
                    type="text"
                    id="artwork-location"
                    placeholder="Auction House tel(Global)"
                    v-model="newItem.auction_house_tel"
                  />
                </div>
                <div class="input-group-item">
                  <label for="artwork-location"
                    >Auction House website(Global)</label
                  >
                  <input
                    type="url"
                    id="artwork-location"
                    placeholder="Auction House website(Global)"
                    v-model="newItem.auction_house_website"
                  />
                </div>
                <div class="input-group-item">
                  <label for="artwork-location"
                    >Auction House introduction message(ENG)</label
                  >
                  <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="5"
                    placeholder="Auction House introduction message(ENG)"
                    v-model="newItem.auction_house_description_eng"
                  ></textarea>
                </div>
                <div class="input-group-item">
                  <label for="artwork-location">경매회사 소개글(KOR)</label>
                  <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="5"
                    placeholder="경매회사 소개글"
                    v-model="newItem.auction_house_description_kor"
                  ></textarea>
                </div>
                <div class="input-group-item">
                  <label for="artwork-location">Crawling Channel</label>
                  <input
                    type="text"
                    placeholder="Crawling Channel"
                    v-model="newItem.crawling_channel"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="form-header">
                <h3>Auction House Image</h3>
              </div>
              <div class="input-group">
                <div class="input-group-item">
                  <label for="artist-name">Photo</label>
                  <o-upload
                    :multiple="false"
                    :uploadUrl="'files/upload'"
                    @imagesUploaded="
                      (data) => {
                        newItem.auction_house_image = data;
                      }
                    "
                    @imagesUploadedFailed="
                      (data) => {
                        console.log('failed');
                      }
                    "
                    :value="newItem.auction_house_image"
                    @startLoader="() => $startLoader()"
                    @stopLoader="() => $stopLoader()"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="form-header">
                <h3>Auction House Banner</h3>
              </div>
              <div class="input-group">
                <div class="input-group-item">
                  <label for="artist-name">Photo</label>
                  <o-upload
                    :multiple="false"
                    :uploadUrl="'files/upload'"
                    @imagesUploaded="
                      (data) => {
                        newItem.auction_house_banner = data;
                      }
                    "
                    @imagesUploadedFailed="
                      (data) => {
                        console.log('failed');
                      }
                    "
                    :value="newItem.auction_house_banner"
                    @startLoader="() => $startLoader()"
                    @stopLoader="() => $stopLoader()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allartWorks: [
        {
          id: 1,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "red",
          salesPrice: "N/A",
          hammerPrice: "121.00",
          status: "Sold",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 2,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "pink",
          salesPrice: "590.00",
          hammerPrice: "N/A",
          status: "Available",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 3,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "yellow",
          salesPrice: "N/A",
          hammerPrice: "121.00",
          status: "Available",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 4,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "Green",
          salesPrice: "590.00",
          hammerPrice: "N/A",
          status: "Available",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 5,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "Orange",
          salesPrice: "N/A",
          hammerPrice: "121.00",
          status: "Available",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
      ],
      artWorks: [],
      checkedItems: [],
      artists: [
        {
          id: 1,
          name: "Leo Da Vinci",
        },
        {
          id: 2,
          name: "Leo Da Vinci",
        },
        {
          id: 3,
          name: "Leo Da Vinci",
        },
        {
          id: 4,
          name: "Leo Da Vinci",
        },
        {
          id: 5,
          name: "Leo Da Vinci",
        },
        {
          id: 6,
          name: "Leo Da Vinci",
        },
        {
          id: 7,
          name: "Leo Da Vinci",
        },
        {
          id: 8,
          name: "Leo Da Vinci",
        },
        {
          id: 9,
          name: "Leo Da Vinci",
        },
        {
          id: 10,
          name: "Leo Da Vinci",
        },
        {
          id: 11,
          name: "Leo Da Vinci",
        },
        {
          id: 12,
          name: "Leo Da Vinci",
        },
        {
          id: 13,
          name: "Leo Da Vinci",
        },
        {
          id: 14,
          name: "Leo Da Vinci",
        },
        {
          id: 15,
          name: "Leo Da Vinci",
        },
        {
          id: 16,
          name: "Leo Da Vinci",
        },
        {
          id: 17,
          name: "Leo Da Vinci",
        },
        {
          id: 18,
          name: "Leo Da Vinci",
        },
        {
          id: 19,
          name: "Leo Da Vinci",
        },
        {
          id: 20,
          name: "Leo Da Vinci",
        },
        {
          id: 21,
          name: "Leo Da Vinci",
        },
        {
          id: 22,
          name: "Leo Da Vinci",
        },
        {
          id: 23,
          name: "Leo Da Vinci",
        },
        {
          id: 24,
          name: "Leo Da Vinci",
        },
        {
          id: 25,
          name: "Leo Da Vinci",
        },
        {
          id: 26,
          name: "Leo Da Vinci",
        },
        {
          id: 27,
          name: "Leo Da Vinci",
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      newItem: {
        auction_house_name_eng: "",
        auction_house_name_kor: "",
        auction_house_location_eng: "",
        auction_house_location_kor: "",
        auction_house_image: "",
        auction_house_description_eng: "",
        auction_house_description_kor: "",
        auction_house_email: "",
        auction_house_tel: "",
        auction_house_website: "",
        auction_house_banner: "",
      },
      actionType: "Add",
    };
  },
  methods: {
    checkedContains(id) {
      return this.checkedItems.includes(id);
    },
    checkNow(id) {
      if (this.checkedItems.includes(id)) {
        this.checkedItems = this.checkedItems.filter((item) => item !== id);
      } else {
        this.checkedItems.push(id);
      }
    },
    checkAllNow() {
      this.checkedItems = [];
      this.artWorks.forEach((artwork) => {
        this.checkedItems.push(artwork.id);
      });
    },
    changePage(page) {
      this.currentPage = page;
      this.artWorks = this.$changePage(
        this.allartWorks,
        page,
        this.itemsPerPage
      );
      window.scrollTo(0, 0);
    },
    saveItem() {
      this.$startLoader();
      this.$store
        .dispatch("ADD_AUCTIONHOUSE", {
          data: this.newItem,
          token: this.$getToken(),
        })
        .then((res) => {
          this.$stopLoader();
          if (res.data.status == "error") {
            this.$notify({
              type: "error",
              title: "Something went wrong",
              text: res.data.message,
            });
          } else {
            this.$notify({
              type: "success",
              title: "Success",
              text: res.data.message,
            });
            this.$router.push({ name: "AdminAuctionHouses" });
          }
        })
        .catch((err) => {
          this.$stopLoader();
          if (err.response.status == 400) {
            err.response.data.errors.forEach((error) => {
              this.$notify({
                type: "error",
                title: "Something went wrong",
                text: error.msg,
              });
            });
          }
          if (err.response.status == 401) {
            this.$notify({
              type: "error",
              title: "Authentication failed",
              text: err.response.data.message,
            });
            this.$router.push({ name: "AdminLogin" });
          }
        });
    },
    updateItem() {
      this.$startLoader();
      this.$store
        .dispatch("UPDATE_AUCTIONHOUSE", {
          data: this.newItem,
          token: this.$getToken(),
        })
        .then((res) => {
          this.$stopLoader();
          if (res.data.status == "error") {
            this.$notify({
              type: "error",
              title: "Something went wrong",
              text: res.data.message,
            });
          } else {
            this.$notify({
              type: "success",
              title: "Success",
              text: res.data.message,
            });
            this.$router.push({ name: "AdminAuctionHouses" });
          }
        })
        .catch((err) => {
          this.$stopLoader();
          if (err.response.status == 400) {
            err.response.data.errors.forEach((error) => {
              this.$notify({
                type: "error",
                title: "Something went wrong",
                text: error.msg,
              });
            });
          }
          if (err.response.status == 401) {
            this.$notify({
              type: "error",
              title: "Authentication failed",
              text: err.response.data.message,
            });
            this.$router.push({ name: "AdminLogin" });
          }
        });
    },
    getItems() {
      this.$startLoader();
      this.$store
        .dispatch("GET_AUCTIONHOUSE_BYID", {
          id: this.$route.params.id,
          token: this.$getToken(),
        })
        .then((res) => {
          this.$stopLoader();
          this.newItem = res.data;
        })
        .catch((err) => {
          this.$stopLoader();
          // if (err.response.status == 400) {
          //   err.response.data.errors.forEach((error) => {
          //     this.$notify({
          //       type: "error",
          //       title: "Something went wrong",
          //       text: error.msg,
          //     });
          //   });
          // }
          // if (err.response.status == 401) {
          //   this.$notify({
          //     type: "error",
          //     title: "Authentication failed",
          //     text: err.response.data.message,
          //   });
          //   this.$router.push({ name: "AdminLogin" });
          // }
        });
    },
  },
  mounted() {
    this.changePage(1);
    this.actionType = this.$route.params.actionType;
    if (this.actionType == "Edit") {
      this.getItems();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
@import "@/assets/scss/dashboard.scss";
</style>